import { SignUpState } from '../components/sign-up/interfaces/sign-up-store.interface';
import { SignUpRequest } from '../models/sign-up-request.model';
import formeJuridiquesData from '../../../assets/json/formesJuridiques.json';
import { FormeJuridique } from '../models/forme-juridique.model';
import countriesData from '../../shared/data/temporary_country_list.json';

export const findCountryByLabel = (label: string | null) =>
  countriesData.find((c) => c.pays === label) ?? null;

export const mapSignUpStateToRequest = (
  state: SignUpState,
  captchaToken: string,
): SignUpRequest => ({
  captcha_token: captchaToken,
  organism: {
    country_code: findCountryByLabel(state.company.country)?.country ?? null,
    vat_number: state.company.vatNumber!,
    registration_number: state.company.siret!,
    name: state.company.name!.trim(),
    industry_type: state.company.industryType,
    legal_status:
      formeJuridiquesData.formesJuridiques.find(
        (fj: FormeJuridique) => fj.label === state.company.legalStatus,
      )?.code ?? null,
    tax_code: findCountryByLabel(state.company.country)?.taxCode ?? null,
    address_line_1: state.company.address1!,
    address_line_2: state.company.address2 || null,
    address_line_3: state.company.address3 || null,
    city: state.company.city!,
    postal_code: state.company.postalCode!,
    phone: state.company.phoneNumber!,
  },
  user: {
    firstname: state.informations.firstname!,
    lastname: state.informations.lastname!,
    email: state.informations.email!,
    login: state.informations.login!,
  },
});
